/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 /**
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 document.addEventListener("DOMContentLoaded", () => {
    let userType = getCookie("userType");
    let toggle = document.querySelector(".toggle input[type='checkbox']");
    let cart_notification_wrapper = document.querySelector(".cart_notification_wrapper");
    let notification_b2b = document.querySelector(".cart_notification.b2b");
    let notification_b2c = document.querySelector(".cart_notification.b2c");
    let cart_notification_wrapper_mobile = document.querySelector(".cart_notification_wrapper_mobile");
    let notification_b2b_mobile = document.querySelector(".cart_notification_mobile.b2b");
    let notification_b2c_mobile = document.querySelector(".cart_notification_mobile.b2c");
    let main_button = document.querySelector("button.cart__checkout-button[type='submit']");
    let dummy_button = document.querySelector("button.button_dummy");
    let quant_select = document.querySelector("line-item-quantity");
    let threshold = (userType)?5:3;

    let total = 0;
    document.querySelectorAll(".hidden-phone .quantity-selector__input").forEach(function(input) {
        const inputValue = parseFloat(input.value) || 0;
        console.log(input.getAttribute("product_type"));
        if(input.getAttribute("product_type")=="Mappe"||input.getAttribute("product_type")=="Paket"){
          total += 99;
        };
        total += inputValue;
    });

    if(userType){
        toggle.checked = true;
        notification_b2b.classList.remove("hidden");
        notification_b2b_mobile.classList.remove("hidden");
        notification_b2c.classList.add("hidden");
        notification_b2c_mobile.classList.add("hidden");
    }else{
        toggle.checked = false;
        notification_b2b.classList.add("hidden");
        notification_b2b_mobile.classList.add("hidden");
        notification_b2c.classList.remove("hidden");
        notification_b2c_mobile.classList.remove("hidden");
    }

    toggle?.addEventListener("change", event=>{
        if(toggle.checked){
            let d = new Date();
            d.setTime(d.getTime() + (14*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = "userType=b2b;" + expires + ";path=/";
        }else{
            document.cookie = "userType=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
        }
        quant_select._updateFromLink("/cart"); // I abuse the Quantselector with a no change url to reload the section
    })

    if(total >= threshold){
      cart_notification_wrapper.classList.add("hidden");
      cart_notification_wrapper_mobile.classList.add("hidden");
      //main_button.classList.remove("hidden");
      //dummy_button.classList.add("hidden");
    }else{
      cart_notification_wrapper.classList.remove("hidden");
      cart_notification_wrapper_mobile.classList.remove("hidden");
      //main_button.classList.add("hidden");
      //dummy_button.classList.remove("hidden");
    }
})

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

